export default async function ({
                                 store,
                                 params,
                                 error,
                                 app
                               }) {
  await store.dispatch('journal/fetch', {
    id: params.id,
    params: {
      lang: app.i18n.locale,
      resolution: 'micro'
    }
  })
    .then(() => {
      const journal = store.getters['journal/journal']
      if (!(journal && journal?.status === 'active')) {
        error({statusCode: 404})
      }
    })
}
